import { FileStatus } from "@jsq/ds/core";
import { DocumentType } from "../../../lib/graphql/supergraph.index";
import { BaseDocumentType } from "../../../lib/graphql/supergraphOperations";
import { DocumentFormProps } from "../documents/DocumentCollector/types";
import { getDocumentCategoryInfo } from "../documents/DocumentCollector/utils";

export const getExistingProfileDocumentsOrDefault = (
  docType: BaseDocumentType,
  profileId: number,
  documents: Array<DocumentType>,
): DocumentFormProps[] => {
  const idDocumentCategory = getDocumentCategoryInfo(docType);
  const matches = documents.filter(
    (doc) => doc.profileId === profileId && doc.documentPurpose?.baseType === docType,
  );
  if (matches.length > 0) {
    const mapped = matches.map((doc) => ({
      baseType: doc.documentPurpose?.baseType ?? docType,
      subType: null,
      file: {
        status: "accepted" as FileStatus,
        file: new File([], doc.name),
        uuid: `${doc.id}`,
        url: doc.s3Link,
      },
      title: idDocumentCategory.title,
      description: idDocumentCategory.description,
    }));
    return mapped;
  }
  return [
    {
      baseType: docType,
      subType: null,
      file: null,
      title: idDocumentCategory.title,
      description: idDocumentCategory.description,
    },
  ];
};
